import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ICrisisManagement } from '../models/crisisManagement';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class CrisisManagementService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getCrisisManagement(buildingId: string): Observable<{has_error: boolean, message: string, data: ICrisisManagement}> {
        const url = environment.apiBaseUrl + endpoints.getCrisisManagement.replace(':buildingId', buildingId);
        return this.http.get<{has_error: boolean, message: string, data: ICrisisManagement}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateCrisisManagement(buildingId: string, data: ICrisisManagement): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.updateCrisisManagement.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
        catchError(this.errorService.handleError)
        );
    }

    approveCrisisManagement(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.approveCrisisManagement.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: any}>(url, {}).pipe(
            catchError(this.errorService.handleError)
        );
    }
}